module.exports = __webpack_public_path__ + "static/media/UK.a7b271d4.svg";